const skills = [
  { name: "AI Product Development", level: 85 },
  { name: "Product Thinking & Strategy", level: 85 },
  { name: "Frontend Engineering", level: 95 },
  { name: "React / Next.js", level: 90 },
  { name: "UI / UX & Design Systems", level: 90 },
  { name: "AI Integration & API Development", level: 80 },
  { name: "Responsive & Accessible Interfaces", level: 90 },
  { name: "Git / GitHub & Deployment", level: 90 },
];

export default skills;